import { AuthProvider } from '@/auth/application/AuthContext';
import NavigationScroll from '@/common/presentation/components/layout/NavigationScroll';
import { RouterProvider } from 'react-router-dom';
import router from '@/common/main/routes';

const rootScrollStyle: React.CSSProperties = {
  height: '100vh',
  overflow: 'auto',
  WebkitOverflowScrolling: 'touch',
  overscrollBehavior: 'auto',
};

const App = () => {
  return (
    <NavigationScroll>
      <AuthProvider>
        <div className="root-scroll-container" style={rootScrollStyle}>
          <RouterProvider router={router} />
        </div>
      </AuthProvider>
    </NavigationScroll>
  );
};

export default App;
